import { client } from '../apiClient';
import { BotAccessResponse } from '../../types/bot-access/BotAccessResponse';

const BOT_ACCESS_ENDPOINT = '/bot-access';

export const getBotAccess = async (projectId: number): Promise<BotAccessResponse> => {
  const { data } = await client(true, true).get<BotAccessResponse>(
    `${BOT_ACCESS_ENDPOINT}/${projectId}`
  );
  return data;
};

export const refreshBotAccess = async (projectId: number): Promise<BotAccessResponse> => {
  const { data } = await client(true, true).post<BotAccessResponse>(
    `${BOT_ACCESS_ENDPOINT}/${projectId}/refresh`
  );
  return data;
};
